class Navigation {
  constructor($el) {
    this.$el = $el;

    if (!this.$el.length) return;

    this.$links = this.$el.find(".navigation__item");
    this.$sections = $("#pumpen, #ueberuns, #kontakt");

    this.observer = null;

    this.init();
  }

  init = () => {
    if (!this.$links.length || !this.$sections.length) return;

    this.observer = new IntersectionObserver(this.handleIntersection, {
      rootMargin: "-100px 0px -40% 0px",
      threshold: 0,
    });

    this.$sections.each((i, section) => {
      this.observer.observe(section);
    });
  };

  handleIntersection = (entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      const sectionId = entry.target.id;

      this.$links.removeClass("active");

      this.$links.filter(`[href="#${sectionId}"]`).addClass("active");
    });
  };
}

export default Navigation;
